// External libraries
import { useEffect } from 'react';
import { useStoreActions } from '@/store';

//Internal modules
import { features } from '@/lib';
import { getWpsMemberMatchEligiblity } from '@/lib/features/featureEligibility';

export const useCheckMemberBenefits = (): void => {
  const setCheckForMemberBenefits = useStoreActions(
    s => s.ui.setCheckForMemberBenefits,
  );
  const isMemberMatchEligibleReqAndOptSignup = features.isActive(
    'isMemberMatchEligibleReqAndOptSignup',
  );

  const isMemberMatchingWpsEligible = getWpsMemberMatchEligiblity();

  /*
    Perform member match check if Optional, Required or WPS Optional
    signups are in place. And WPS POMA experiment is not active.
  */
  useEffect(() => {
    if (isMemberMatchEligibleReqAndOptSignup || isMemberMatchingWpsEligible) {
      setCheckForMemberBenefits(true);
    }
  }, [isMemberMatchEligibleReqAndOptSignup, isMemberMatchingWpsEligible]);
};
